var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[(_vm.hasCount)?_c('SearchResultCount',{attrs:{"category":_vm.category,"total-count":_vm.totalCount}}):_vm._e(),(_vm.hasFilterList)?_c('div',{staticClass:"filter-wrap"},[_c('FilterList',{attrs:{"filter":_vm.filter}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }